import React from "react";

// Without a boundary, any render error (or a page chunk that still fails after
// lazyWithRetry's reload) unmounts the whole app and leaves a blank white page.
// resetKey (the current path) clears the error when the visitor navigates away.
class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Page failed to render:", error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: "24px",
          textAlign: "center",
          color: "black",
        }}
      >
        <h2 style={{ fontWeight: 600 }}>Something went wrong</h2>
        <p style={{ margin: "12px 0 24px" }}>
          Please reload the page. If it keeps happening, try again in a minute.
        </p>
        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", justifyContent: "center" }}>
          <button
            onClick={() => window.location.reload()}
            style={{
              backgroundColor: "#ff3d2e",
              color: "white",
              border: "none",
              padding: "10px 24px",
              borderRadius: "5px",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Reload page
          </button>
          <a
            href="/"
            style={{
              border: "1px solid #ff3d2e",
              color: "#ff3d2e",
              padding: "10px 24px",
              borderRadius: "5px",
              fontWeight: 600,
              textDecoration: "none",
            }}
          >
            Go to home
          </a>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
